import React, { FC } from "react";
import { COLOR_GREY_6 } from "../colors";
import { IconType } from "./types";

export const HeartIcon: FC<IconType> = ({ color = COLOR_GREY_6 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3722 21.7589C12.8063 21.5291 23 15.9643 23 9.08929C22.9982 7.47486 22.356 5.92709 21.2145 4.78552C20.0729 3.64395 18.5251 3.00182 16.9107 3C14.8826 3 13.1069 3.87214 12 5.34634C10.8931 3.87214 9.11741 3 7.08929 3C5.47487 3.00182 3.92709 3.64395 2.78552 4.78552C1.64395 5.92709 1.00182 7.47486 1 9.08929C1 15.9643 11.1937 21.5291 11.6278 21.7589C11.7422 21.8205 11.8701 21.8527 12 21.8527C12.1299 21.8527 12.2578 21.8205 12.3722 21.7589Z"
      fill={color}
    />
  </svg>
);
